import React, {} from 'react'
import {Redirect} from 'react-router-dom'

const Illegal = () => <Redirect to={'/Illegal/carcheck'}/>;

export default Illegal;
